import React, { createContext, useContext, useEffect, useState } from 'react';

import { getFeatureFlags } from '../services/featureFlagService';

export const FEATURE_SUBSCRIPTION_ENFORCEMENT = 'subscription_enforcement';

const FeatureFlagContext = createContext(null);

export const useFeatureFlags = () => {
  const context = useContext(FeatureFlagContext);
  if (!context) {
    throw new Error('useFeatureFlags must be used within a FeatureFlagProvider');
  }
  return context;
};

export const useFeatureFlag = (key) => {
  const { isEnabled } = useFeatureFlags();
  return isEnabled(key);
};

export const FeatureFlagProvider = ({ children }) => {
  const [flags, setFlags] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const data = await getFeatureFlags();
        if (!cancelled && data?.success) {
          setFlags(data.flags ?? {});
        }
      } catch (err) {
        console.error('Failed to load feature flags:', err);
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  const isEnabled = (key) => Boolean(flags[key]);

  const value = {
    flags,
    loading,
    isEnabled,
  };

  return (
    <FeatureFlagContext.Provider value={value}>
      {children}
    </FeatureFlagContext.Provider>
  );
};
